<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import AirplayIcon from '../icons/AirplayIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
</script>

<ControlBarButton
  tooltip={translationsStore.state.airplay}
  hidden={!videoStore.state.isAirplaySupported}
  onclick={() => videoStore.state.videoController?.toggleAirplay()}
>
  <AirplayIcon />
</ControlBarButton>
